import { useEffect, useState } from "react";
import { IoIosClose, IoMdOpen } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import mixpanel from "mixpanel-browser";
import { useInfluencer } from "@/Providers/Influencer";
import {
  Table,
  TableCaption,
  TableHeader,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
} from "@/shadcnComponents/ui/table";
import { Button } from "@/shadcnComponents/ui/button";
import MobileMenuBar from "@/Components/Menubar/MobileMenuBar";

const AnalyticCard = ({ numbers, title, description, action, actiontext }) => {
  return (
    <div className="min-w-[296px] max-w-[296px] font-inter flex flex-col justify-center items-center gap-3 flex-[1_0_0] self-stretch p-5 border border-neutral-800 rounded-md border-dashed">
      <span className="text-white text-3xl not-italic font-bold leading-6">
        {numbers}
      </span>
      <span className="text-white text-sm not-italic font-semibold leading-6">
        {title}
      </span>
      <span className="text-neutral-400 text-center text-xs not-italic font-normal leading-5 self-stretch">
        {description}
      </span>
      <div
        onClick={() => action()}
        className="flex text-[#DC2627] hover:text-[#EF4C60]  cursor-pointer justify-center items-center gap-1 px-2 py-1.5"
      >
        <span className="text-xs not-italic font-medium leading-[normal]">
          {actiontext}
        </span>
        <IoMdOpen size={14} />
      </div>
    </div>
  );
};
const AnalyticPopUpCard = ({ action, tableHead, tableRow, tableCaption }) => {
  return (
    <div className="w-screen h-screen flex items-center justify-center bg-[#121212c2] fixed top-0 left-0 right-0 bottom-0 z-[999] font-inter filter backdrop-blur">
      <div className="w-3/4  h-1/2 text-white flex justify-center items-center">
        <div className="flex w-full  h-full  p-[20px] flex-col items-center rounded-[8px] bg-[#303035] [box-shadow:0px_10px_20px_0px_rgba(0,_0,_0,_0.10)]">
          <div className="w-full flex justify-end">
            <Button
              variant="ghost"
              size="icon"
              className="hover:bg-[#1e1e20]"
              onClick={() => action()}
            >
              <IoIosClose color={"#ffffff"} size={24} />
            </Button>
          </div>

          <TableCaption className="mb-[10px] sticky top-0">
            {tableCaption}
          </TableCaption>

          <Table
            style={{ scrollbarWidth: "none" }}
            className="caption-top overflow-x-none bg-[#262626]"
          >
            <TableHeader
              style={{ scrollbarWidth: "none" }}
              className="sticky top-0 "
            >
              <TableRow className="">
                <TableHead className="text-center bg-[#262626] text-[#fff] border-[#262626]">
                  S. No
                </TableHead>
                {tableHead?.map((item, index) => {
                  return (
                    <TableHead
                      key={index}
                      className="text-center bg-[#262626] border-[#262626] rounded-none text-[#fff]"
                    >
                      {item}
                    </TableHead>
                  );
                })}
              </TableRow>
            </TableHeader>
            <TableBody
              style={{ scrollbarWidth: "none" }}
              className=" h-[90%] overflow-x-none"
            >
              {tableRow?.[0]?.map((row, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell
                      key={index}
                      className="text-center text-[#fff] bg-[#5A5A5A] border-[#262626] "
                    >
                      {index + 1}
                    </TableCell>
                    {row?.map((cell, index) => {
                      return (
                        <TableCell
                          key={index}
                          className="text-center text-[#fff] bg-[#5A5A5A] border-[#262626]"
                        >
                          {cell}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          {tableRow?.[0]?.length < 1 && (
            <p className="mt-3">No items to display</p>
          )}
        </div>
      </div>
    </div>
  );
};

export const Analytics = () => {
  const navigate = useNavigate();
  const influencerState = useInfluencer();
  const [Analytics, SetAnalytics] = useState<{
    success: boolean;
    dealEarning?: [];
    revenueEarning?: [];
    numberOfUnlocks?: [];
    numberOfReferrals?: [];
    totalViews?: number;
  }>();
  const [tableData, settableData] = useState({
    tableCaption: "",
    tableHeaders: [],
    tableCells: [],
  });
  const [openAnalyticPopUp, setopenAnalyticPopup] = useState(false);

  const getDate = (date) => {
    const d = new Date(date);

    const newDate = d.toDateString().split(" ");

    return (
      // newDate[0] + " | " + newDate[1] + " " + newDate[2] + " " + newDate[3]
      newDate[2] + " " + newDate[1] + " " + newDate[3]
    );
  };

  useEffect(() => {
    mixpanel.track("Visted Analytics Page");
    const getAllAnalytics = async () => {
      const result = await influencerState?.getAnalytics();
      if (result.success) {
        SetAnalytics(result);
      }
    };
    getAllAnalytics();
  }, []);
  return (
    <>
      <MobileMenuBar />
      {openAnalyticPopUp && (
        <AnalyticPopUpCard
          action={() => setopenAnalyticPopup(false)}
          tableHead={tableData.tableHeaders}
          tableRow={tableData.tableCells}
          tableCaption={tableData.tableCaption}
        />
      )}

      <div className="w-full font-inter px-10 py-5 box-border pb-[100px] flex items-center justify-between h-max ">
        <section className="flex flex-col gap-[30px] w-full">
          <span className="text-[14px] md:text-[24px] font-[600] text-[#FFFFFF]  ">
            Your Profile Performance at a Glance!
          </span>
          <div className="flex flex-wrap items-center justify-center md:items-start  gap-y-8 gap-x-4 shrink-0">
            {/* <AnalyticCard
              numbers={Analytics?.totalViews || 0}
              title={"👩🏻‍🤝‍👩🏼 Profile Views"}
              description={
                "See how many people are checking out your Collab profile. The more viewers, the more brands and creators notice your talent!"
              }
              action={() => {
                mixpanel.track("Clicked on Get More Visitors");
                window.open(
                  "https://go.anchors.in/visitorprofilegrow",
                  "_blank"
                );
              }}
              actiontext={"Get More Visitors"}
            /> */}

            <AnalyticCard
              numbers={Analytics?.numberOfReferrals?.length || 0}
              title={"👩🏻‍🤝‍👩🏼 Referral Network"}
              description={
                "Know how many creators joined using your referral code. You both earn chips when you refer friends!"
              }
              action={() => {
                mixpanel.track("Clicked on View Creators");
                settableData({
                  tableCaption:
                    "Here is a comprehensive list of all creators referred by you!",
                  tableHeaders: ["Name", "Registered On"],
                  tableCells: [
                    Analytics?.numberOfReferrals?.map((item) => [
                      item?.name,
                      getDate(item?.createdAt),
                    ]),
                  ],
                });
                setopenAnalyticPopup(true);
              }}
              actiontext={"View Creators"}
            />
            {/* <AnalyticCard
              numbers={`₹ ${
                Analytics?.dealEarning?.[0]?.totalEarnings?.$numberDecimal || 0
              }`}
              title={"💰 Collab Earnings"}
              description={
                "Track your total income from deals gotten through anchors|Collab. Keep an eye out for new opportunities!"
              }
              action={undefined}
              actiontext={"Land More Deals"}
            /> */}
            <AnalyticCard
              numbers={
                Analytics?.revenueEarning?.[0]?.totalEarnings?.$numberDecimal ||
                0
              }
              title={"💰 Revenue Share"}
              description={
                "See your income from brands unlocking your contact info through your Collab profile. The more they check it out, the more you earn!"
              }
              action={() => {
                mixpanel.track("Clicked on Increase Profile Payouts");
                window.open(
                  "https://go.anchors.in/Revenue-sharing-guide",
                  "_blank"
                );
              }}
              actiontext={"Increase Profile Payouts"}
            />
            <AnalyticCard
              numbers={Analytics?.numberOfUnlocks?.length || 0}
              title={"🫱🏼‍🫲🏽 Brand Reach"}
              description={
                "Discover how many brands unlocked your profile when searching for creators on anchors|collab. It means you're on their dashboard(& radar)!"
              }
              action={() => {
                mixpanel.track("Clicked on View Brands");
                settableData({
                  tableCaption:
                    "Here's a comprehensive list of brands that have unlocked your profile!",
                  tableHeaders: ["Company Name", "Unlocked On"],
                  tableCells: [
                    Analytics?.numberOfUnlocks?.map((item) => [
                      item?.companyName,
                      getDate(item?.createdAt),
                    ]),
                  ],
                });
                setopenAnalyticPopup(true);
              }}
              actiontext={"View Brands"}
            />
          </div>
        </section>
      </div>
    </>
  );
};
